(function () {
  'use strict';

  // Auto-play videos when in view, pause when out
  function initVideos() {
    const videos = document.querySelectorAll('video[data-autoplay-inview]');
    if (!videos.length || !('IntersectionObserver' in window)) return;

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const v = entry.target;
        if (entry.isIntersecting) {
          v.play().catch(() => {});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.4 });

    videos.forEach((v) => io.observe(v));
  }

  // Sound toggle button per chapter video
  function initSoundToggle() {
    document.querySelectorAll('[data-video-sound-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const wrap = btn.closest('[data-vitace-video]');
        if (!wrap) return;
        const v = wrap.querySelector('video');
        if (!v) return;
        v.muted = !v.muted;
        const mutedIcon = btn.querySelector('.icon-muted');
        const soundIcon = btn.querySelector('.icon-sound');
        if (mutedIcon && soundIcon) {
          mutedIcon.style.display = v.muted ? '' : 'none';
          soundIcon.style.display = v.muted ? 'none' : '';
        }
        btn.setAttribute('aria-label', v.muted ? 'Ativar som do vídeo' : 'Silenciar vídeo');
      });
    });
  }

  // Hide chrome on scroll down, show on scroll up
  function initChromeScroll() {
    const chrome = document.querySelector('[data-vitace-chrome]');
    if (!chrome) return;
    let lastY = window.scrollY;
    let ticking = false;

    function update() {
      const y = window.scrollY;
      if (y < 120) {
        chrome.removeAttribute('data-hidden');
      } else if (y > lastY + 8) {
        chrome.setAttribute('data-hidden', 'true');
      } else if (y < lastY - 8) {
        chrome.removeAttribute('data-hidden');
      }
      lastY = y;
      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  }

  // Reveal chapters on scroll (subtle fade-up)
  function initReveals() {
    if (!('IntersectionObserver' in window)) return;
    const targets = document.querySelectorAll('.vitace-chapter, .vitace-manifesto__pillar, .vitace-timeline-i__milestone');
    targets.forEach((el) => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(30px)';
      el.style.transition = 'opacity 0.8s ease, transform 0.8s ease';
    });

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    targets.forEach((el) => io.observe(el));
  }

  // Carousel horizontal — sync thumbs ↔ scroll position ↔ arrows + autoplay
  function initCarousel() {
    const AUTOPLAY_MS = 6000;
    const TICK_MS = 80;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-vitace-carousel]').forEach((carousel) => {
      const track = carousel.querySelector('[data-carousel-track]');
      const slides = Array.from(carousel.querySelectorAll('[data-carousel-slide]'));
      const thumbs = Array.from(carousel.querySelectorAll('[data-carousel-thumb]'));
      const prevBtn = carousel.querySelector('[data-carousel-prev]');
      const nextBtn = carousel.querySelector('[data-carousel-next]');
      const counter = carousel.querySelector('[data-carousel-counter]');
      const progressFill = carousel.querySelector('[data-carousel-progress-fill]');
      if (!track || !slides.length) return;

      let current = 0;

      function setActive(i) {
        // Disable clamp so wrap-around works (allow any index, normalize)
        const n = slides.length;
        current = ((i % n) + n) % n;
        thumbs.forEach((t, idx) => t.setAttribute('aria-current', idx === current ? 'true' : 'false'));
        if (counter) counter.innerHTML = `<strong>${String(current + 1).padStart(2, '0')}</strong> / ${String(n).padStart(2, '0')}`;
        // Wrap-around: setas nunca ficam disabled
        if (prevBtn) prevBtn.disabled = false;
        if (nextBtn) nextBtn.disabled = false;
      }

      function scrollToIndex(i) {
        const n = slides.length;
        const idx = ((i % n) + n) % n;
        const target = slides[idx];
        if (!target) return;
        track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      }

      thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', () => { restartAutoplay(); setActive(i); scrollToIndex(i); });
      });

      if (prevBtn) prevBtn.addEventListener('click', () => { restartAutoplay(); scrollToIndex(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', () => { restartAutoplay(); scrollToIndex(current + 1); });

      // Sync active state com scroll (IntersectionObserver nas slides)
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
              const idx = slides.indexOf(entry.target);
              if (idx >= 0 && idx !== current) setActive(idx);
            }
          });
        }, { root: track, threshold: [0.5, 0.75] });
        slides.forEach((s) => io.observe(s));
      }

      // Teclado: setas
      carousel.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { restartAutoplay(); scrollToIndex(current - 1); e.preventDefault(); }
        else if (e.key === 'ArrowRight') { restartAutoplay(); scrollToIndex(current + 1); e.preventDefault(); }
      });

      // --- Autoplay (6s com barra de progresso, pausa em hover/focus/touch) ---
      let elapsed = 0;
      let tickTimer = null;
      let paused = false;

      function setPausedAttr(v) {
        if (v) carousel.setAttribute('data-autoplay-paused', 'true');
        else carousel.removeAttribute('data-autoplay-paused');
      }

      function updateProgress() {
        if (!progressFill) return;
        const pct = Math.min(100, (elapsed / AUTOPLAY_MS) * 100);
        progressFill.style.width = pct + '%';
      }

      function stopTick() {
        if (tickTimer) { clearInterval(tickTimer); tickTimer = null; }
      }

      function startTick() {
        stopTick();
        if (reduceMotion) return;
        tickTimer = setInterval(() => {
          if (paused || document.hidden) return;
          elapsed += TICK_MS;
          updateProgress();
          if (elapsed >= AUTOPLAY_MS) {
            elapsed = 0;
            updateProgress();
            scrollToIndex(current + 1);
          }
        }, TICK_MS);
      }

      function restartAutoplay() {
        elapsed = 0;
        updateProgress();
      }

      function pauseAutoplay() { paused = true; setPausedAttr(true); }
      function resumeAutoplay() { paused = false; setPausedAttr(false); }

      // Pausa em interações do usuário
      carousel.addEventListener('mouseenter', pauseAutoplay);
      carousel.addEventListener('mouseleave', resumeAutoplay);
      carousel.addEventListener('focusin', pauseAutoplay);
      carousel.addEventListener('focusout', resumeAutoplay);
      carousel.addEventListener('touchstart', () => { pauseAutoplay(); restartAutoplay(); }, { passive: true });

      // Pausa quando a aba perde foco
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) pauseAutoplay(); else resumeAutoplay();
      });

      setActive(0);
      startTick();
    });
  }

  function init() {
    initVideos();
    initSoundToggle();
    initChromeScroll();
    initReveals();
    initCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
